import { Cable, Boxes, Scale, Gauge } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SectionShell, SectionHead, IconChip } from "@/components/site/Primitives";

const CAPS = [
  { icon: Cable, tint: "blue", title: "Connect", copy: "Bring together approved enterprise, maritime, contractual and external information." },
  { icon: Boxes, tint: "blue", title: "Understand", copy: "Structure entities, relationships, obligations, commercial conditions and dependencies." },
  { icon: Scale, tint: "gold", title: "Reason", copy: "Quantify commercial and financial impact, evaluate risk and compare scenarios." },
  { icon: Gauge, tint: "gold", title: "Decide", copy: "Deliver prioritised recommendations with rationale, confidence, evidence and human approval." },
];

export function WhatNatsu() {
  return (
    <SectionShell id="platform" tone="white">
      <div className="max-w-3xl">
        <SectionHead
          label="The Platform"
          labelColor="gold"
          size="xl"
          title="One connected commercial-intelligence platform. A shared, explainable basis for decision-making."
          intro="NATSU Intelligence does not replace ERP, VMS, TMS, contract, legal, market-data or operational systems. It is designed to sit above and connect them, applying commercial context, financial reasoning and scenario intelligence to support governed executive decisions."
        />
      </div>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {CAPS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.07}>
            <div className="flex h-full flex-col rounded-2xl border border-natsu-navy/12 bg-white p-6 transition-all duration-300 hover:border-natsu-navy/25 hover:shadow-[0_18px_44px_-24px_rgba(10,23,41,0.28)] sm:p-7">
              <div className="flex items-center gap-3">
                <IconChip icon={c.icon} tint={c.tint} />
                <span className="font-display text-2xl text-natsu-navy">{c.title}</span>
              </div>
              <p className="mt-5 text-[14.5px] leading-relaxed text-natsu-slate">{c.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Category hierarchy */}
      <Reveal>
        <div className="mt-14 overflow-hidden rounded-2xl border border-natsu-navy/10 bg-natsu-mist">
          <div className="grid grid-cols-1 divide-y divide-natsu-navy/[0.08] sm:grid-cols-3 sm:divide-x sm:divide-y-0">
            <div className="p-8">
              <p className="eyebrow text-natsu-slate">Category</p>
              <p className="mt-3 font-display text-lg leading-snug text-natsu-navy">Commercial Intelligence Infrastructure</p>
            </div>
            <div className="p-8">
              <p className="eyebrow text-natsu-slate">Delivered through</p>
              <p className="mt-3 font-display text-lg leading-snug text-natsu-navy">NATSU Commercial Intelligence Platform</p>
            </div>
            <div className="p-8">
              <p className="eyebrow text-natsu-slate">Powered by</p>
              <p className="mt-3 font-display text-lg leading-snug text-natsu-navy">NATSU Commercial Knowledge Operating System™</p>
            </div>
          </div>
        </div>
      </Reveal>
    </SectionShell>
  );
}
